module.exports = __webpack_public_path__ + "src/assets/games/22/122.jpg";